import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import styled from "styled-components";
import axios from "axios";

const API_BASE_URL   = "https://admin.shopaholics.ge/api";
const API_LIST_PAGED = `${API_BASE_URL}/products_list.php`;   // server-side paging (items,total,page,page_size,…)
const API_LIST_FULL  = `${API_BASE_URL}/product_list.php`;    // სრული სია (fallback)
const API_UPDATE_URL = `${API_BASE_URL}/update_perfume.php`;
const API_DELETE_URL = `${API_BASE_URL}/delete_perfume.php`;
const API_UPLOAD_URL = `${API_BASE_URL}/upload_images.php`;
const API_GET_BRANDS = `${API_BASE_URL}/get_brands.php`;

axios.defaults.headers.common["Accept"] = "application/json";

/* ==== UI ==== */
const Page = styled.div`max-width:1100px;margin:24px auto;padding:0 16px 28px;`;
const H1 = styled.h1`font-size:22px;font-weight:900;margin:0 0 16px;`;
const Card = styled.div`background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:14px;box-shadow:0 10px 30px rgba(0,0,0,.06);padding:16px;margin-bottom:14px;`;
const CardTitle = styled.h2`font-size:16px;font-weight:900;margin:2px 0 10px;display:flex;gap:8px;align-items:center;&:before{content:'';width:10px;height:10px;border-radius:999px;background:#0ea5e9;box-shadow:0 0 0 3px rgba(14,165,233,.2);}`;
const Small = styled.small`color:#6b7280;`;
const RowList = styled.div`display:grid;grid-template-columns:64px 1fr auto auto;gap:10px;align-items:center;border:1px solid #f1f5f9;border-radius:10px;padding:10px;`;
const Cover = styled.img`width:64px;height:64px;border-radius:10px;object-fit:cover;background:#f3f4f6;`;
const Ghost = styled.button`height:36px;padding:0 12px;font-size:12px;font-weight:800;cursor:pointer;border-radius:10px;border:1px solid #e5e7eb;background:#f7f7f8;color:#111827;&:disabled{opacity:.5;}`;
const Danger = styled(Ghost)`border-color:#fca5a5;background:#fee2e2;color:#991b1b;`;
const ErrorBox = styled.pre`white-space:pre-wrap;background:#fff7ed;border:1px solid #fdba74;color:#7c2d12;padding:12px;border-radius:12px;`;
const Grid2 = styled.div`display:grid;gap:16px;grid-template-columns:2fr 1fr;@media (max-width:1000px){grid-template-columns:1fr;}`;
const Label = styled.label`font-size:12px;font-weight:800;color:#111827;display:grid;gap:6px;`;
const Input = styled.input`height:40px;padding:0 12px;border-radius:10px;border:1px solid #e5e7eb;font-size:14px;outline:none;&:focus{border-color:#0ea5e9;box-shadow:0 0 0 3px rgba(14,165,233,.15);}`;
const Select = styled.select`height:40px;padding:0 12px;border-radius:10px;border:1px solid #e5e7eb;font-size:14px;outline:none;background:#fff;&:focus{border-color:#0ea5e9;box-shadow:0 0 0 3px rgba(14,165,233,.15);}`;
const Textarea = styled.textarea`min-height:90px;padding:10px 12px;border-radius:10px;resize:vertical;border:1px solid #e5e7eb;font-size:14px;outline:none;&:focus{border-color:#0ea5e9;box-shadow:0 0 0 3px rgba(14,165,233,.15);}`;
const Button = styled.button`height:42px;padding:0 16px;font-size:14px;font-weight:900;cursor:pointer;border-radius:12px;border:1px solid rgba(0,0,0,.08);background:#111827;color:#fff;box-shadow:0 10px 30px rgba(0,0,0,.08);&:disabled{opacity:.55;}`;
const Pager = styled.div`display:flex;gap:6px;align-items:center;flex-wrap:wrap;`;
const ImagesWrap = styled.div`display:flex;gap:10px;flex-wrap:wrap;`;
const Thumb = styled.div`
  width:92px;height:92px;border-radius:10px;border:1px solid #e5e7eb;overflow:hidden;position:relative;background:#f7f7f8;
  img{width:100%;height:100%;object-fit:cover;display:block;}
  .x{position:absolute;top:6px;right:6px;height:26px;width:26px;display:grid;place-items:center;border-radius:999px;background:#111827;color:#fff;font-weight:900;border:1px solid rgba(255,255,255,.6);cursor:pointer;}
`;
const MlRow = styled.div`
  display:grid;gap:8px;grid-template-columns:.7fr .7fr .7fr 1.6fr auto;align-items:start;
  @media (max-width:900px){grid-template-columns:1fr 1fr 1fr 1fr auto;}
  @media (max-width:700px){grid-template-columns:1fr;}
`;
const SectionTitle = styled.div`font-size:13px;font-weight:900;color:#111827;margin-top:4px;`;

const ModalOverlay = styled.div`
  position: fixed; inset:0; z-index: 2000; background: rgba(0,0,0,.5);
  display:grid; place-items:center; -webkit-overflow-scrolling: touch; overflow:auto;
`;
const ModalCard = styled.div`
  width: min(560px, 92%); background:#fff; border:1px solid rgba(0,0,0,.08);
  border-radius: 16px; box-shadow: 0 16px 50px rgba(0,0,0,.2); padding: 16px;
`;
const ModalHead = styled.div`
  display:flex; align-items:center; justify-content:space-between; margin-bottom:8px;
  h3{ margin:0; font-size:16px; font-weight:900; }
`;
const List = styled.ul`
  margin:0; padding:0; list-style:none; max-height: 360px; overflow:auto;
  border:1px solid #e5e7eb; border-radius: 12px;
`;
const Item = styled.li`
  padding:10px 12px; border-bottom:1px solid #f1f5f9; cursor:pointer;
  &:last-child{ border-bottom:none } &:hover{ background:#f8fafc; }
`;
const AB = styled.div`
  display:flex; flex-wrap:wrap; gap:6px; margin:8px 0 10px;
`;

/* ==== helpers ==== */

const capFirst = (s) => {
  const t = String(s || "").trim();
  return t ? t[0].toUpperCase() + t.slice(1) : "";
};
const mergeBrands = (intoSet, arr=[]) => {
  const next = new Set(intoSet);
  const seen = new Set(Array.from(next).map(v => v.toLowerCase()));
  arr.forEach(n => {
    const v = capFirst(n);
    if (v && !seen.has(v.toLowerCase())) {
      next.add(v);
      seen.add(v.toLowerCase());
    }
  });
  return next;
};

const PER_ML_CATEGORIES = ["skin-care","hair-and-body-care","atomizers"];
const COLOR_OPTIONS = [
  { ka:"შავი", en:"Black" }, { ka:"თეთრი", en:"White" }, { ka:"ლურჯი", en:"Blue" },
  { ka:"წითელი", en:"Red" }, { ka:"მწვანე", en:"Green" }, { ka:"ნაცრისფერი", en:"Gray" },
  { ka:"ვერცხლისფერი", en:"Silver" }, { ka:"ოქროსფერი", en:"Gold" },
];
const SIZES = [{key:"small",label:"Small"},{key:"regular",label:"Regular"},{key:"large",label:"Large"}];

const getCover = (p) => {
  if (Array.isArray(p.imageUrls) && p.imageUrls[0]) return p.imageUrls[0];
  const ml0 = Array.isArray(p.milliliters) ? p.milliliters.find(m => Array.isArray(m.images) && m.images.length) : null;
  if (ml0) return ml0.images[0];
  const v0 = Array.isArray(p.accessory_variants) ? p.accessory_variants.find(v => Array.isArray(v.images) && v.images.length) : null;
  if (v0) return v0.images[0];
  return "";
};

function formatLoadError(err, resp, url) {
  try{
    if (resp) {
      const { status, statusText, headers={}, data } = resp;
      const isString = typeof data === "string";
      const first = isString ? String(data).slice(0,1000) : JSON.stringify(data,null,2);
      return [
        `LOAD: ვერ დავაპარსე JSON.`,
        `HTTP ${status ?? ""} ${statusText ?? ""} — GET ${url}`,
        `headers: ${JSON.stringify(headers,null,2)}`,
        `raw body (first 1000 chars):`,
        first,
      ].join("\n");
    }
    return `LOAD ERROR: ${err?.message || String(err)}`;
  }catch(e){ return `LOAD ERROR (format): ${String(e)}`; }
}

async function uploadImages(files){
  if (!files || files.length===0) return [];
  const fd = new FormData();
  Array.from(files).forEach(f => fd.append("images", f));
  const r = await axios.post(API_UPLOAD_URL, fd, {
    withCredentials:false,
    headers:{ "Content-Type":"multipart/form-data", Accept:"application/json" },
    validateStatus: () => true,
  });
  if (r.status<200 || r.status>=300) throw new Error(`Upload HTTP ${r.status}`);
  if (r?.data?.error) throw new Error(String(r.data.error));
  return r.data?.imageUrls || [];
}

/* ==== URL <-> state ==== */
const readQS = () => {
  const sp = new URLSearchParams(window.location.search);
  const num = (x, def)=>{ const n=Number(x); return Number.isFinite(n)&&n>0?n:def; };
  return {
    page:     num(sp.get("page"), 1),
    pageSize: num(sp.get("page_size"), 20),
    q:        sp.get("q") || "",
    product_id: sp.get("product_id") || "",
    name:       sp.get("name") || "",
    brand:      sp.get("brand") || "",
    category:   sp.get("category") || "",
  };
};

/* ==== Component ==== */
export default function ProductsManager(){
  // --- filters + pagination (hydrate from URL once) ---
  const init = useRef(false);
  const qs = readQS();
  const [q, setQ] = useState(qs.q);
  const [filter, setFilter] = useState({ product_id:qs.product_id, name:qs.name, brand:qs.brand, category:qs.category });
  const [page, setPage] = useState(qs.page);
  const [pageSize, setPageSize] = useState(qs.pageSize);

  // --- dynamic dropdown sources ---
  const [brandSet, setBrandSet] = useState(()=>new Set());
  const [catSet,   setCatSet]   = useState(()=>new Set());

  // --- data ---
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loadErr, setLoadErr] = useState("");
  const [usingServerPaging, setUsingServerPaging] = useState(true);
  const [fullList, setFullList] = useState([]);

  // --- editor ---
  const [editing, setEditing] = useState(null);
  const [productImages, setProductImages] = useState({ existing:[], files:[] });
  const [ml, setMl] = useState([]);
  const [fullStock, setFullStock] = useState(0);
  const [variants, setVariants] = useState([]);

  const isPerfume = editing?.category === "perfume";
  const isMlCategory = isPerfume || PER_ML_CATEGORIES.includes(editing?.category || "");
  const isAccessories = editing?.category === "accessories";
  const location = useLocation();
  const navigate = useNavigate();
  const [prodPickerKey, setProdPickerKey] = useState(0);

  const writeQS = (state) => {
    const sp = new URLSearchParams();
    sp.set("page", String(state.page));
    sp.set("page_size", String(state.pageSize));
    if (state.q) sp.set("q", state.q);
    if (state.filter.product_id) sp.set("product_id", state.filter.product_id);
    if (state.filter.name)       sp.set("name", state.filter.name);
    if (state.filter.brand)      sp.set("brand", state.filter.brand);
    if (state.filter.category)   sp.set("category", state.filter.category);
    const url = `${location.pathname}?${sp.toString()}`;
    navigate(url, { replace: true });
    window.history.replaceState({}, "", url);
  };

  // --- brand modal state ---
  const [showBrandModal, setShowBrandModal] = useState(false);
  const [brandSearch, setBrandSearch] = useState("");
  const [brandLetter, setBrandLetter] = useState("");
  const [brandChoices, setBrandChoices] = useState([]);
  const [brandPickContext, setBrandPickContext] = useState(null); // 'filter' | 'editing' | null

  useEffect(() => {
    const all = Array.from(brandSet).sort((a,b)=>a.localeCompare(b));
    const filtered = all.filter(
      b => b.toLowerCase().includes(brandSearch.toLowerCase())
        && (brandLetter === "" || b.toUpperCase().startsWith(brandLetter))
    );
    setBrandChoices(filtered);
  }, [brandSet, brandSearch, brandLetter]);

  // ===== URL sync on changes =====
  useEffect(() => {
    if (!init.current) return;
    writeQS({ page, pageSize, q, filter });
  }, [page, pageSize, q, filter]);

  // initial mount
  useEffect(() => { init.current = true; writeQS({ page, pageSize, q, filter }); }, []);

  // ===== loaders =====
  const buildParams = () => {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("page_size", String(pageSize));
    if (q) params.set("q", q);
    Object.entries(filter).forEach(([k,v])=>{ if (v) params.set(k, v); });
    return params.toString();
  };

const absorbOptionsFrom = (arr = []) => {
  setBrandSet(prev => {
    const next = new Set(prev);
    arr.forEach(p => {
      if (p?.brand) next.add(capFirst(String(p.brand)));
    });
    return next;
  });
  setCatSet(prev => {
    const next = new Set(prev);
    arr.forEach(p => {
      if (p?.category) next.add(String(p.category));
    });
    return next;
  });
};


useEffect(() => {
  (async () => {
    try {
     const r = await axios.get(API_GET_BRANDS, { validateStatus: () => true /*, withCredentials:true */ });
     if (r.status < 200 || r.status >= 300) {
       console.warn("get_brands non-200", r.status, r.data);
       return;
     }
      const apiNames = Array.isArray(r.data) ? r.data.map(b => b.name).filter(Boolean) : [];
      setBrandSet(prev => mergeBrands(prev, apiNames));
    } catch (e) { console.error("get_brands failed", e); }
  })();
}, []);


  const loadServerPaged = async () => {
    const url = `${API_LIST_PAGED}?${buildParams()}`;
    const r = await axios.get(url, { validateStatus: () => true });
    if (r.status<200 || r.status>=300) throw { response:r, url };
    if (!r.data || typeof r.data!=="object" || !Array.isArray(r.data.items)) throw { response:r, url };
    setUsingServerPaging(true);
    setItems(r.data.items || []);
    setTotal(Number(r.data.total || 0));
    setLoadErr("");
    absorbOptionsFrom(r.data.items || []);
  };

  const loadFullAndFilter = async () => {
    const url = API_LIST_FULL;
    const r = await axios.get(url, { validateStatus: () => true });
    if (r.status<200 || r.status>=300) throw { response:r, url };
    const arr = Array.isArray(r.data) ? r.data : [];
    setUsingServerPaging(false);
    setFullList(arr);
    setLoadErr("");
    absorbOptionsFrom(arr);
  };

  const load = async () => {
    setLoadErr("");
    try {
      await loadServerPaged();
    } catch (e1) {
      try {
        await loadFullAndFilter();
      } catch (e2) {
        const resp = e2?.response || e1?.response;
        const url  = e2?.url || e1?.url || API_LIST_PAGED;
        setLoadErr(formatLoadError(e2 || e1, resp, url));
        setItems([]); setTotal(0); setFullList([]);
      }
    }
  };

  useEffect(() => {
    if (usingServerPaging) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, q, filter.product_id, filter.name, filter.brand, filter.category]);

  // client-side filtering/paging
  const filteredClient = useMemo(() => {
    if (usingServerPaging) return { pageItems: items, total };
    const norm = s => String(s||"").toLowerCase();
    const qq = norm(q);
    const f  = filter;

    let rows = fullList.filter(p => {
      const byQ =
        !qq ||
        norm(p.product_id).includes(qq) ||
        norm(p.name).includes(qq) ||
        norm(p.brand).includes(qq) ||
        norm(p.category).includes(qq);
      const byId    = !f.product_id || norm(p.product_id).includes(norm(f.product_id));
      const byName  = !f.name || norm(p.name).includes(norm(f.name));
      const byBrand = !f.brand || norm(p.brand) === norm(f.brand);
      const byCat   = !f.category || String(p.category||"") === f.category;
      return byQ && byId && byName && byBrand && byCat;
    });

    const _total = rows.length;
    const start = (page-1)*pageSize;
    const end   = start + pageSize;
    return { pageItems: rows.slice(start, end), total: _total };
  }, [usingServerPaging, fullList, items, total, q, filter, page, pageSize]);

  useEffect(() => {
    if (!usingServerPaging) {
      setItems(filteredClient.pageItems);
      setTotal(filteredClient.total);
    }
  }, [usingServerPaging, filteredClient]);

  /* ===== Filters UI ===== */
  const onSearch = (e)=>{ e.preventDefault(); setPage(1); if(usingServerPaging) load(); };
  const resetFilters = ()=>{
    setQ(""); setFilter({product_id:"",name:"",brand:"",category:""}); setPage(1);
    if (usingServerPaging) load();
  };
  const totalPages = Math.max(1, Math.ceil((usingServerPaging? total : filteredClient.total) / pageSize));
  const go = (p)=> setPage(Math.min(Math.max(1,p), totalPages));

  // Dropdown options (sorted)
  const brandOptions = useMemo(() => Array.from(brandSet).sort((a,b)=>a.localeCompare(b)), [brandSet]);
  const categoryOptions = useMemo(() => Array.from(catSet).sort((a,b)=>a.localeCompare(b)), [catSet]);

  /* ===== Editor (unchanged core) ===== */
  const openEdit = (p) => {
    setEditing(p);
    setProductImages({ existing:Array.isArray(p.imageUrls)?p.imageUrls:[], files:[] });

    const mlRows = Array.isArray(p.milliliters) ? p.milliliters : [];
 setMl(mlRows.map(m => {
   const mode = (m.stock_mode === 'units' || m.stock_mode === 'auto') ? m.stock_mode : 'auto';
   return {
     size: m.size ?? "",
     price: m.price ?? "",
     unit_stock: (p.category==="perfume")
       ? (mode==='auto' ? ("" /* UI-ში ავტომატურად დაითვლება on size/fullStock */) : (m.unit_stock ?? ""))
       : (m.unit_stock ?? m.stock ?? ""),
     stock_mode: (p.category==="perfume") ? mode : 'units',
     existing: Array.isArray(m.images) ? m.images : [],
     files: [],
     pickerKey: 0,
   };
 }));
    setVariants((Array.isArray(p.accessory_variants)?p.accessory_variants:[]).map(v => ({
      color_ka: v.color_ka ?? v.color ?? "",
      color_en: v.color_en ?? "",
      size_label: v.size_label ?? "regular",
      price: v.price ?? "",
      stock: v.stock ?? "",
      existing: Array.isArray(v.images) ? v.images : [],
      files: [],
      pickerKey: 0,
    })));
    setFullStock(Number(p.full_stock || 0));
  };

  const onDelete = async (p) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.email) return alert("Unauthorized");
    if (!window.confirm(`წავშალო ${p.name}?`)) return;
    try{
      const r = await axios.post(API_DELETE_URL, { id:p.product_id, email:user.email }, {
        withCredentials:true, headers:{ "Content-Type":"application/json" }, validateStatus: () => true,
      });
      if (r.status<200 || r.status>=300 || r.data?.error) { alert(`Delete failed: ${r.data?.error || r.status}`); return; }
      if (usingServerPaging) load();
      else setFullList(prev => prev.filter(x => x.product_id !== p.product_id));
      alert("წაიშალა");
    }catch(e){ console.error(e); alert("Delete failed"); }
  };

  const ch = e => setEditing(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const chCat = e => { const val=e.target.value; setEditing(prev => ({ ...prev, category: val })); if (val!=="perfume") setFullStock(0); };

  // product gallery
  const addProductFiles = files => setProductImages(prev => ({ ...prev, files:[...prev.files, ...Array.from(files||[])] }));
  const delProductExisting = idx => setProductImages(prev => ({ ...prev, existing: prev.existing.filter((_,i)=>i!==idx) }));
  const delProductFile = idx => setProductImages(prev => ({ ...prev, files: prev.files.filter((_,i)=>i!==idx) }));

  // ml rows
  const addMlRow = () => setMl(prev => [...prev, { size:"", price:"", unit_stock:"", existing:[], files:[], pickerKey:0 }]);
  const delMlRow = i => setMl(prev => prev.filter((_,idx)=>idx!==i));
 const chMl = (i, field, value) => setMl(prev => {
   const c=[...prev];
   c[i][field]=value;
   if (isPerfume && field==="size" && (c[i].stock_mode ?? 'auto') === 'auto'){
     const mlv=parseFloat(value);
     c[i].unit_stock=(Number.isFinite(mlv)&&mlv>0&&fullStock>0)?Math.floor(fullStock/mlv):"";
   }
   return c;
});
  const addMlFiles = (i, files) => setMl(prev => { const c=[...prev]; c[i].files=[...c[i].files, ...Array.from(files||[])]; return c; });
  const delMlExisting = (i, idx) => setMl(prev => { const c=[...prev]; c[i].existing=c[i].existing.filter((_,j)=>j!==idx); return c; });
  const delMlFile = (i, idx) => setMl(prev => { const c=[...prev]; c[i].files=c[i].files.filter((_,j)=>j!==idx); return c; });

  // variants
  const addVariant = (color_ka) => {
    const m = COLOR_OPTIONS.find(x=>x.ka===color_ka);
    setVariants(prev => [...prev, { color_ka, color_en:m?.en||"", size_label:"regular", price:"", stock:"", existing:[], files:[], pickerKey:0 }]);
  };
  const delVariant = i => setVariants(prev => prev.filter((_,idx)=>idx!==i));
  const chVar = (i, field, value) => setVariants(prev => { const c=[...prev]; c[i][field]=value; return c; });

  const chMlMode = (i, mode) => setMl(prev => {
  const c=[...prev];
  c[i].stock_mode = mode; // 'auto' | 'units'
  if (isPerfume && mode==='auto') {
    const mlv = parseFloat(c[i].size);
    c[i].unit_stock = (Number.isFinite(mlv)&&mlv>0&&fullStock>0)?Math.floor(fullStock/mlv):"";
  }
  return c;
});

  const onSave = async () => {
    if (!editing) return;
    try{
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.email) { alert("Unauthorized."); return; }

      const prodNew = await uploadImages(productImages.files);
      const prodAll = [...productImages.existing, ...prodNew];

      const mlPayload = [];
      for (const r of ml){
        const empty = (r.size??"")==="" && (r.price??"")==="" && (r.unit_stock??"")==="" && (!r.existing?.length) && (!r.files?.length);
        if (empty) continue;
        const newUrls = await uploadImages(r.files);
 const mode = (r.stock_mode ?? 'auto');
 mlPayload.push({
   size: r.size===""? null : Number(r.size),
   price: r.price===""? 0 : Number(r.price),
   unit_stock: isPerfume
     ? (mode==='auto' ? null : (r.unit_stock===""? 0 : Number(r.unit_stock)))
     : (r.unit_stock===""? 0 : Number(r.unit_stock)),
   stock_mode: isPerfume ? mode : 'units',
   imageUrls: [...(r.existing||[]), ...newUrls],
 });
      }

      const varPayload = [];
      for (const v of variants){
        const newUrls = await uploadImages(v.files);
        varPayload.push({
          color_ka: v.color_ka,
          color_en: v.color_en,
          size_label: v.size_label || "regular",
          price: v.price===""? null : Number(v.price),
          stock: v.stock===""? 0 : parseInt(v.stock,10),
          imageUrls: [...(v.existing||[]), ...newUrls],
        });
      }

      const payload = {
        product_id: editing.product_id,
        email: user.email,
        name: editing.name || "", name_en: editing.name_en || "",
        sex: editing.sex || "", category: editing.category || "perfume", brand: capFirst(editing.brand || ""),
        description: editing.description || "", description_en: editing.description_en || "",
        note: editing.note || "", note_en: editing.note_en || "",
        concentration: editing.concentration || "", concentration_en: editing.concentration_en || "",
        aroma: editing.aroma || "", aroma_en: editing.aroma_en || "",
        full_stock: isPerfume ? Number(fullStock||0) : 0,
        ingredients: editing.ingredients || "", ingredients_en: editing.ingredients_en || "",
        method_of_use: editing.method_of_use || "", method_of_use_en: editing.method_of_use_en || "",
        purpose_problem: editing.purpose_problem || "", purpose_problem_en: editing.purpose_problem_en || "",
        product_type: editing.product_type || "", product_type_en: editing.product_type_en || "",
        skin_type: editing.skin_type || "", skin_type_en: editing.skin_type_en || "",
        subcategory: editing.subcategory || "", color: editing.color || "", color_en: editing.color_en || "",
        use: editing.use || "", use_en: editing.use_en || "", material: editing.material || "", material_en: editing.material_en || "",
        price_p: editing.price_p ?? null,
        imageUrls: prodAll,
        milliliters: isMlCategory ? mlPayload : [],
        accessories_variants: isAccessories ? varPayload : [],
      };

      const res = await axios.post(API_UPDATE_URL, payload, {
        withCredentials:true, headers:{ "Content-Type":"application/json", Accept:"application/json" }, validateStatus: () => true,
      });
      if (res.status<200 || res.status>=300 || res.data?.error) { alert(`Save failed: ${res.data?.error || res.status}`); return; }
      alert("შენახულია!");
      setEditing(null);
      if (usingServerPaging) load();
      else {
        const updated = { ...editing, imageUrls: payload.imageUrls, milliliters: payload.milliliters, accessory_variants: payload.accessories_variants };
        setFullList(prev => prev.map(x => x.product_id===updated.product_id ? updated : x));
      }
    }catch(e){ console.error(e); alert(`Save failed: ${e?.message || String(e)}`); }
  };

  return (
    <Page>
      <H1>პროდუქტების მენეჯერი</H1>

      {loadErr && (
        <Card>
          <CardTitle>შეცდომა (დიბაგი)</CardTitle>
          <ErrorBox>{loadErr}</ErrorBox>
          <Ghost onClick={load}>თავიდან ჩატვირთვა</Ghost>
        </Card>
      )}

      {!editing && (
        <Card>
          <CardTitle>ძიება / ფილტრები</CardTitle>
          <form onSubmit={onSearch} style={{display:"grid",gap:10}}>
            <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
              <Label>საერთო (q)<Input value={q} onChange={e=>{setQ(e.target.value); setPage(1);} } placeholder="id, სახელი, ბრენდი, კატეგორია…" /></Label>
              <Label>პროდუქტის ნომერი <Input value={filter.product_id} onChange={e=>{setFilter(s=>({...s,product_id:e.target.value})); setPage(1);} } /></Label>
            </div>
            <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
              <Label>სახელი <Input value={filter.name} onChange={e=>{setFilter(s=>({...s,name:e.target.value})); setPage(1);} } /></Label>

              <Label>ბრენდი
                <Input
                  list="brandsListFilter"
                  value={filter.brand}
                  onChange={e => { setFilter(s => ({ ...s, brand: e.target.value })); setPage(1); }}
                  placeholder="შეიყვანე ან აირჩიე სიიდან"
                />
                <datalist id="brandsListFilter">
                  {brandOptions.map(b => <option key={b} value={b} />)}
                </datalist>

                <Small style={{ marginTop: 4 }}>
                  ან აირჩიე სიიდან დეტალური ძიებით:{" "}
                  <Ghost
                    type="button"
                    onClick={() => {
                      setBrandPickContext('filter');
                      setBrandSearch("");
                      setBrandLetter("");
                      setShowBrandModal(true);
                    }}
                  >
                    Existing brands…
                  </Ghost>
                </Small>
              </Label>
            </div>
            <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
              <Label>კატეგორია
                <Select value={filter.category} onChange={e=>{setFilter(s=>({...s,category:e.target.value})); setPage(1);} }>
                  <option value="">—</option>
                  {categoryOptions.length
                    ? categoryOptions.map(c => <option key={c} value={c}>{c}</option>)
                    : ["perfume","skin-care","hair-and-body-care","atomizers","accessories"].map(c => <option key={c} value={c}>{c}</option>)
                  }
                </Select>
              </Label>
              <Label>გვერდზე ჩანაწერები
                <Select value={pageSize} onChange={e=>{const v=Number(e.target.value); setPageSize(v); setPage(1); if(usingServerPaging) load();}}>
                  {[10,20,30,50,100].map(n => <option key={n} value={n}>{n}</option>)}
                </Select>
              </Label>
            </div>
            <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
              <Button type="submit">ძებნა</Button>
              <Ghost type="button" onClick={resetFilters}>გასუფთავება</Ghost>
              {!usingServerPaging && <Small style={{marginLeft:8}}>client-side რეჟიმი (fallback)</Small>}
            </div>
          </form>
        </Card>
      )}

      {!editing && !loadErr && (
        <Card>
          <CardTitle>ჩამონათვალი</CardTitle>
          {(usingServerPaging ? items : filteredClient.pageItems).length===0 ? (
            <Small>ვერ მოიძებნა…</Small>
          ) : (
            <div style={{display:'grid',gap:8}}>
              {(usingServerPaging ? items : filteredClient.pageItems).map(p=>(
                <RowList key={p.product_id}>
                  <Cover src={getCover(p)} alt="" />
                  <div>
                    <div style={{fontWeight:900}}>{p.name} <Small>({p.product_id})</Small></div>
                    <Small>{p.brand || "—"} • {p.category}</Small>
                  </div>
                  <Ghost onClick={()=>openEdit(p)}>Edit</Ghost>
                  <Danger onClick={()=>onDelete(p)}>Delete</Danger>
                </RowList>
              ))}
            </div>
          )}
          <div style={{marginTop:12, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <Small>სულ: {usingServerPaging ? total : filteredClient.total} • გვერდი {page}/{totalPages}</Small>
            <Pager>
              <Ghost onClick={()=>go(1)} disabled={page<=1}>« პირველი</Ghost>
              <Ghost onClick={()=>go(page-1)} disabled={page<=1}>‹ უკან</Ghost>
              <Ghost onClick={()=>go(page+1)} disabled={page>=totalPages}>წინ ›</Ghost>
              <Ghost onClick={()=>go(totalPages)} disabled={page>=totalPages}>ბოლო »</Ghost>
            </Pager>
          </div>
        </Card>
      )}

      {editing && (
        <>
          <Card>
            <CardTitle>ძირითადი ინფორმაცია</CardTitle>
            <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
              <Label>დასახელება <Input name="name" value={editing.name||""} onChange={ch} /></Label>
              <Label>დასახელება (EN) <Input name="name_en" value={editing.name_en||""} onChange={ch} /></Label>
            </div>
            <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
              <Label>სქესი
                <Select name="sex" value={editing.sex||""} onChange={ch}>
                  <option value="">—</option><option value="woman">Woman</option><option value="man">Man</option><option value="kids">Kids</option><option value="unisex">Unisex</option>
                </Select>
              </Label>
              <Label>კატეგორია
                <Select name="category" value={editing.category||"perfume"} onChange={chCat}>
                  <option value="perfume">Perfume</option><option value="skin-care">Skin Care</option><option value="hair-and-body-care">Hair and Body Care</option><option value="atomizers">Atomizers</option><option value="accessories">Accessories</option>
                </Select>
              </Label>
            </div>

            {editing.category==="accessories" && (
              <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                <Label>აქსესუარის ტიპი
                  <Select name="subcategory" value={editing.subcategory||""} onChange={ch}>
                    <option value="">აირჩიეთ</option><option value="sunglasses">Sunglasses</option><option value="bags">Bags</option>
                  </Select>
                </Label>
                <div />
              </div>
            )}

            <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
              <Label>ბრენდი
                <Input
                  name="brand"
                  list="brandsListEdit"
                  value={editing.brand || ""}
                  onChange={ch}
                  placeholder="შეიყვანე ან აირჩიე სიიდან"
                />
                <datalist id="brandsListEdit">
                  {Array.from(brandSet).sort((a,b)=>a.localeCompare(b)).map(b => (
                    <option key={b} value={b} />
                  ))}
                </datalist>

                <Small style={{ marginTop: 4 }}>
                  ან აირჩიე სიიდან დეტალური ძიებით:{" "}
                  <Ghost
                    type="button"
                    onClick={() => {
                      setBrandPickContext('editing');
                      setBrandSearch("");
                      setBrandLetter("");
                      setShowBrandModal(true);
                    }}
                  >
                    Existing brands…
                  </Ghost>
                </Small>
              </Label>

              {isPerfume && <Label>Full stock (ml) <Input type="number" value={fullStock} onChange={e=>setFullStock(parseInt(e.target.value||"0",10))} /></Label>}
            </div>

            {isPerfume && (
              <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                <Label>Concentration (EN) <Input name="concentration_en" value={editing.concentration_en||""} onChange={ch} /></Label>
                <Label>Aromas (EN) <Input name="aroma_en" value={editing.aroma_en||""} onChange={ch} /></Label>
              </div>
            )}

            <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
              <Label>აღწერა <Textarea name="description" value={editing.description||""} onChange={ch} /></Label>
              <Label>აღწერა (EN) <Textarea name="description_en" value={editing.description_en||""} onChange={ch} /></Label>
            </div>

            <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
              <Label>შენიშვნა <Textarea name="note" value={editing.note||""} onChange={ch} /></Label>
              <Label>შენიშვნა (EN) <Textarea name="note_en" value={editing.note_en||""} onChange={ch} /></Label>
            </div>

            {(editing.category==="skin-care" || editing.category==="hair-and-body-care") && (
              <>
                <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                  <Label>ინგრედიენტები <Textarea name="ingredients" value={editing.ingredients||""} onChange={ch} /></Label>
                  <Label>ინგრედიენტები (EN) <Textarea name="ingredients_en" value={editing.ingredients_en||""} onChange={ch} /></Label>
                </div>
                <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                  <Label>გამოყენების წესი <Textarea name="method_of_use" value={editing.method_of_use||""} onChange={ch} /></Label>
                  <Label>გამოყენების წესი (EN) <Textarea name="method_of_use_en" value={editing.method_of_use_en||""} onChange={ch} /></Label>
                </div>
                <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                  <Label>დანიშნულება / პრობლემა <Textarea name="purpose_problem" value={editing.purpose_problem||""} onChange={ch} /></Label>
                  <Label>დანიშნულება / პრობლემა (EN) <Textarea name="purpose_problem_en" value={editing.purpose_problem_en||""} onChange={ch} /></Label>
                </div>
                <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                  <Label>პროდუქტის ტიპი <Input name="product_type" value={editing.product_type||""} onChange={ch} /></Label>
                  <Label>პროდუქტის ტიპი (EN) <Input name="product_type_en" value={editing.product_type_en||""} onChange={ch} /></Label>
                </div>
                <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                  <Label>კანის ტიპი <Input name="skin_type" value={editing.skin_type||""} onChange={ch} /></Label>
                  <Label>კანის ტიპი (EN) <Input name="skin_type_en" value={editing.skin_type_en||""} onChange={ch} /></Label>
                </div>
              </>
            )}

            {editing.category==="accessories" && (
              <>
                <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                  <Label>Material <Input name="material" value={editing.material||""} onChange={ch} /></Label>
                  <Label>Material (EN) <Input name="material_en" value={editing.material_en||""} onChange={ch} /></Label>
                </div>
                <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                  <Label>Use <Textarea name="use" value={editing.use||""} onChange={ch} /></Label>
                  <Label>Use (EN) <Textarea name="use_en" value={editing.use_en||""} onChange={ch} /></Label>
                </div>
                <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr"}}>
                  <Label>Base Price (optional) <Input type="number" step="0.01" name="price_p" value={editing.price_p ?? ""} onChange={ch} /></Label>
                </div>
              </>
            )}
          </Card>

          {/* ML */}
          {isMlCategory && (
            <Card>
              <CardTitle>მილილიტრები</CardTitle>
              <Small>{isPerfume ? "მარაგი ითვლება Full stock-იდან." : "ერთეულების მარაგი თითო ML-ზე."}</Small>
              {ml.map((r,i)=>(
                <MlRow key={i}>
                  <Input type="number" placeholder="Size (ml)" value={r.size} onChange={e=>{const v=e.target.value; setMl(p=>{const c=[...p]; c[i].size=v; if(isPerfume){ const mlv=parseFloat(v); c[i].unit_stock=(Number.isFinite(mlv)&&mlv>0&&fullStock>0)?Math.floor(fullStock/mlv):""; } return c;});}} />
                  <Input type="number" placeholder="Price" value={r.price} onChange={e=>setMl(p=>{const c=[...p]; c[i].price=e.target.value; return c;})} />
   {isPerfume ? (
     <>
       <Select
         value={r.stock_mode ?? 'auto'}
         onChange={e => chMlMode(i, e.target.value)}
       >
         <option value="auto">Auto from Full stock</option>
         <option value="units">Units per bottle</option>
       </Select>
       <Input
         type="number"
         placeholder={(r.stock_mode ?? 'auto')==='auto' ? "Auto stock" : "Stock (units)"}
         value={r.unit_stock}
         readOnly={(r.stock_mode ?? 'auto')==='auto'}
         onChange={e=> (r.stock_mode ?? 'auto')==='units' && chMl(i,'unit_stock',e.target.value)}
       />
     </>
   ) : (
     <Input type="number" placeholder="Stock (units)" value={r.unit_stock}
       onChange={e=>chMl(i,'unit_stock',e.target.value)} />
   )}
                  <div>
                    <SectionTitle>Images (ML)</SectionTitle>
                    <Input
                      key={r.pickerKey || 0}
                      type="file"
                      multiple
                      onChange={e=>{
                        const f=e.target.files;
                        setMl(p=>{
                          const c=[...p];
                          c[i].files=[...(c[i].files||[]), ...Array.from(f||[])];
                          c[i].pickerKey=(c[i].pickerKey||0)+1;
                          return c;
                        });
                      }}
                    />
                    <ImagesWrap style={{marginTop:8}}>
                      {(r.existing||[]).map((u,idx)=>(
                        <Thumb key={`mlex-${idx}`}><img src={u} alt="" /><div className="x"
                          onClick={()=>setMl(p=>{
                            const c=[...p];
                            c[i].existing=c[i].existing.filter((_,j)=>j!==idx);
                            c[i].pickerKey=(c[i].pickerKey||0)+1;
                            return c;
                          })}
                        >×</div></Thumb>
                      ))}
                      {(r.files||[]).map((f,idx)=>(
                        <Thumb key={`mlnf-${idx}`}><img src={URL.createObjectURL(f)} alt="" /><div className="x"
                          onClick={()=>setMl(p=>{
                            const c=[...p];
                            c[i].files=c[i].files.filter((_,j)=>j!==idx);
                            c[i].pickerKey=(c[i].pickerKey||0)+1;
                            return c;
                          })}
                        >×</div></Thumb>
                      ))}
                    </ImagesWrap>
                  </div>
                  <Danger type="button" onClick={()=>setMl(p=>p.filter((_,j)=>j!==i))}>Delete</Danger>
                </MlRow>
              ))}
              <Ghost type="button" onClick={()=>setMl(p=>[...p,{ size:"", price:"", unit_stock:"", existing:[], files:[] }])}>Add ML</Ghost>
            </Card>
          )}

          {/* VARIANTS */}
          {isAccessories && (
            <Card>
              <CardTitle>აქსესუარის ვარიაციები</CardTitle>
              <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr"}}>
                <Label>ფერის არჩევა
                  <Select onChange={e=>{ if(e.target.value){ const m=COLOR_OPTIONS.find(x=>x.ka===e.target.value); setVariants(p=>[...p,{ color_ka:e.target.value, color_en:m?.en||"", size_label:"regular", price:"", stock:"", existing:[], files:[] }]); e.target.value=""; }}}>
                    <option value="">აირჩიე ფერი…</option>
                    {COLOR_OPTIONS.map(c => <option key={c.ka} value={c.ka}>{c.ka}</option>)}
                  </Select>
                </Label>
              </div>
              {variants.map((v,i)=>(
                <div key={i} style={{border:"1px solid #e5e7eb", borderRadius:12, padding:12, marginTop:10}}>
                  <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                    <Label>ფერი (KA) <Input value={v.color_ka} onChange={e=>setVariants(p=>{const c=[...p]; c[i].color_ka=e.target.value; return c;})} /></Label>
                    <Label>ფერი (EN) <Input value={v.color_en} onChange={e=>setVariants(p=>{const c=[...p]; c[i].color_en=e.target.value; return c;})} /></Label>
                  </div>
                  <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                    <Label>ზომა
                      <Select value={v.size_label} onChange={e=>setVariants(p=>{const c=[...p]; c[i].size_label=e.target.value; return c;})}>
                        {SIZES.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
                      </Select>
                    </Label>
                    <Label>ფასი <Input type="number" value={v.price} onChange={e=>setVariants(p=>{const c=[...p]; c[i].price=e.target.value; return c;})} /></Label>
                  </div>
                  <div style={{display:"grid",gap:10,gridTemplateColumns:"1fr 1fr"}}>
                    <Label>მარაგი <Input type="number" value={v.stock} onChange={e=>setVariants(p=>{const c=[...p]; c[i].stock=e.target.value; return c;})} /></Label>
                    <div />
                  </div>
                  <SectionTitle>სურათები (ფერისთვის)</SectionTitle>
                  <Input
                    key={v.pickerKey || 0}
                    type="file"
                    multiple
                    onChange={e=>{
                      const f=e.target.files;
                      setVariants(p=>{
                        const c=[...p];
                        c[i].files=[...(c[i].files||[]), ...Array.from(f||[])];
                        c[i].pickerKey=(c[i].pickerKey||0)+1;
                        return c;
                      });
                    }}
                  />
                  <ImagesWrap style={{marginTop:8}}>
                    {(v.existing||[]).map((u,idx)=>(
                      <Thumb key={`vex-${idx}`}><img src={u} alt="" /><div className="x" onClick={()=>setVariants(p=>{
                        const c=[...p];
                        c[i].existing=c[i].existing.filter((_,j)=>j!==idx);
                        c[i].pickerKey=(c[i].pickerKey||0)+1;
                        return c;
                      })}
                      >×</div></Thumb>
                    ))}
                    {(v.files||[]).map((f,idx)=>(
                      <Thumb key={`vfile-${idx}`}><img src={URL.createObjectURL(f)} alt="" /><div className="x" onClick={()=>setVariants(p=>{
                        const c=[...p];
                        c[i].files=c[i].files.filter((_,j)=>j!==idx);
                        c[i].pickerKey=(c[i].pickerKey||0)+1;
                        return c;
                      })}
                      >×</div></Thumb>
                    ))}
                  </ImagesWrap>
                  <div style={{marginTop:8, display:"flex", justifyContent:"flex-end"}}>
                    <Danger type="button" onClick={()=>setVariants(p=>p.filter((_,j)=>j!==i))}>ვარიაციის წაშლა</Danger>
                  </div>
                </div>
              ))}
            </Card>
          )}

          {/* PRODUCT GALLERY + ACTIONS */}
          <Grid2>
            <Card>
              <CardTitle>Product Images (Gallery)</CardTitle>
              <Small>ეს სურათები მიებმება პროდუქტს მთლიანად.</Small>
              <div style={{marginTop:10}}>
                <Input
                  key={prodPickerKey}
                  type="file"
                  multiple
                  onChange={e=>{
                    const f = e.target.files;
                    setProductImages(prev => ({ ...prev, files: [...prev.files, ...Array.from(f || [])] }));
                    setProdPickerKey(k=>k+1);
                  }}
                />
              </div>

              <ImagesWrap style={{marginTop:10}}>
                {productImages.existing.map((u, idx) => (
                  <Thumb key={`pex-${idx}`}>
                    <img src={u} alt="" />
                    <div
                      className="x"
                      onClick={() => {
                        setProductImages(prev => ({
                          ...prev,
                          existing: prev.existing.filter((_, i) => i !== idx),
                        }));
                        setProdPickerKey(k => k + 1);
                      }}
                    >
                      ×
                    </div>
                  </Thumb>
                ))}

                {productImages.files.map((f, idx) => (
                  <Thumb key={`pfile-${idx}`}>
                    <img src={URL.createObjectURL(f)} alt="" />
                    <div
                      className="x"
                      onClick={() => {
                        setProductImages(prev => ({
                          ...prev,
                          files: prev.files.filter((_, i) => i !== idx),
                        }));
                        setProdPickerKey(k => k + 1);
                      }}
                    >
                      ×
                    </div>
                  </Thumb>
                ))}
              </ImagesWrap>
            </Card>
            <div>
              <Card>
                <CardTitle>ქმედებები</CardTitle>
                <div style={{display:"flex", gap:8, flexWrap:"wrap"}}>
                  <Button onClick={onSave}>შენახვა</Button>
                  <Ghost onClick={()=>setEditing(null)}>გაუქმება</Ghost>
                </div>
              </Card>
            </div>
          </Grid2>
        </>
      )}

      {showBrandModal && (
        <ModalOverlay>
          <ModalCard>
            <ModalHead>
              <h3>აირჩიე ბრენდი</h3>
              <Ghost onClick={()=>{ setShowBrandModal(false); setBrandPickContext(null); }}>Close</Ghost>
            </ModalHead>

            <Input
              placeholder="Search brands…"
              value={brandSearch}
              onChange={e=>setBrandSearch(e.target.value)}
            />

            <AB>
              {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map(ch => (
                <Ghost key={ch} onClick={()=>setBrandLetter(ch)}>{ch}</Ghost>
              ))}
              <Ghost onClick={()=>setBrandLetter("")}>All</Ghost>
            </AB>

            <List>
              {brandChoices.length ? brandChoices.map(name => (
                <Item
                  key={name}
                  onClick={()=>{
                    if (brandPickContext === 'editing') {
                      setEditing(prev => ({ ...prev, brand: capFirst(name) }));
                    } else if (brandPickContext === 'filter') {
                      setFilter(prev => ({ ...prev, brand: capFirst(name) }));
                      setPage(1);
                    }
                    setShowBrandModal(false);
                    setBrandPickContext(null);
                  }}
                >
                  {name}
                </Item>
              )) : <Item>Nothing found</Item>}
            </List>
          </ModalCard>
        </ModalOverlay>
      )}

    </Page>
  );
}
